import { CancelToken } from "axios";

import { IPhoneNumber, IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserPhoneNumberCollection {
  [IDataKeys.userPhoneNumber]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserPhoneNumberService {
  static createUserPhoneNumber = (
    phoneNumber: Partial<IPhoneNumber>
  ): Promise<IJSONAPIUserPhoneNumberCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_PHONE_NUMBERS,
          data: phoneNumber,
        });
        resolve(response as IJSONAPIUserPhoneNumberCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_PHONE_NUMBER);
        reject({ error });
      }
    });

  static getUserPhoneNumbers = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserPhoneNumberCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_PHONE_NUMBERS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserPhoneNumberCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_PHONE_NUMBER);
        reject({ error });
      }
    });

  static editUserPhoneNumber = (
    phoneNumberId: string,
    phoneNumber: Partial<IPhoneNumber>
  ): Promise<IJSONAPIUserPhoneNumberCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_PHONE_NUMBER(phoneNumberId),
          data: phoneNumber,
        });
        resolve(response as IJSONAPIUserPhoneNumberCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_PHONE_NUMBER);
        reject({ error });
      }
    });

  static deleteUserPhoneNumber = (phoneNumberId: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_PHONE_NUMBER(phoneNumberId),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_PHONE_NUMBER);
        reject({ error });
      }
    });
}
